export default "__VITE_ASSET__CflJP4kI__"